import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    // Statements
    OVERDUE_DESC: {
        id: 'accountTimeline.OVERDUE_DESC',
        defaultMessage: 'Statement due date passed without payment',
    },
    CLOSE_DESC: {
        id: 'accountTimeline.CLOSE_DESC',
        defaultMessage: 'Current statement was closed',
    },
    CARD_BLOCK_DESC: {
        id: 'accountTimeline.CARD_BLOCK_DESC',
        defaultMessage:
            'Physical card was blocked due to a past overdue statement',
    },
    PAYMENT_DESC: {
        id: 'accountTimeline.PAYMENT_DESC',
        defaultMessage: 'Payment for the current statement was confirmed',
    },
    PAYMENTS_DESC: {
        id: 'accountTimeline.PAYMENTS_DESC',
        defaultMessage:
            'Money deposited to the platform account from an external environment',
    },
    PARTIAL_PAYMENT_DESC: {
        id: 'accountTimeline.PARTIAL_PAYMENT_DESC',
        defaultMessage: 'Partial payment was confirmed',
    },
    // Credit
    CREDIT_LIMIT_NEAR_DESC: {
        id: 'accountTimeline.CREDIT_LIMIT_NEAR_DESC',
        defaultMessage:
            "The account's credit has exceeded 80 percent of its limit",
    },
    CREDIT_LIMIT_REACHED_DESC: {
        id: 'accountTimeline.CREDIT_LIMIT_REACHED_DESC',
        defaultMessage: 'The account has reached its credit limit',
    },
    // Transaction
    AUTHORIZE_DESC: {
        id: 'accountTimeline.AUTHORIZE_DESC',
        defaultMessage:
            'Transaction was authorized (for example, a purchase was made)',
    },
    CANCELLATION_DESC: {
        id: 'accountTimeline.CANCELLATION_DESC',
        defaultMessage: 'Transaction was canceled',
    },
    REFUSAL_DESC: {
        id: 'accountTimeline.REFUSAL_DESC',
        defaultMessage: 'Transaction was refused',
    },
    // Card
    CREATION_DESC: {
        id: 'accountTimeline.CREATION_DESC',
        defaultMessage: 'Card object for an account was created in the system',
    },
    PRODUCTION_DESC: {
        id: 'accountTimeline.PRODUCTION_DESC',
        defaultMessage:
            'Card information was successfully sent to the embossing company and the card is being manufactured',
    },
    DELIVERY_DESC: {
        id: 'accountTimeline.DELIVERY_DESC',
        defaultMessage:
            'Delivery event for a physical card was filed by the courier company',
    },
    ACTIVATION_DESC: {
        id: 'accountTimeline.ACTIVATION_DESC',
        defaultMessage: 'Physical card was activated',
    },
    BLOCK_DESC: {
        id: 'accountTimeline.BLOCK_DESC',
        defaultMessage:
            'Physical card was (temporarily) blocked by the customer',
    },
    UNBLOCK_DESC: {
        id: 'accountTimeline.UNBLOCK_DESC',
        defaultMessage: 'Physical card was unblocked by the customer',
    },
});

export default enumMessages;
